export const enMenuManagementTranslations = {
  menuManagement: {
    title: 'Menu Management',
    subtitle: 'Manage your restaurant menu items, variants, and settings',
    tabs: {
      announcements: 'Announcements',
      variants: 'Variants',
      ingredients: 'Ingredients',
      dietaryPreferences: 'Dietary Preferences',
      crossSelling: 'Cross-Selling',
      zones: 'Zones'
    },
    announcements: {
      subtitle: 'Manage announcements'
    },
    variants: {
        subtitle: 'Manage variants of menu items'
    },
    ingredients: {
        subtitle: 'Manage ingredients used in menu items'
    },
    ingredientGroups: 'Ingredient Groups',
    searchIngredientsPlaceholder: 'Search ingredients...',
    searchGroupsPlaceholder: 'Search groups...',
    addIngredient: 'Add Ingredient',
    addIngredientGroup: 'Add Ingredient Group',
    dietary: {
        subtitle: 'Manage dietary restrictions and preferences for menu items'
    },
    crossSelling: {
      subtitle: 'Manage item recommendations',
      noRelations: 'No Cross-Selling Configured',
      noRelationsDescription: 'Add cross-selling recommendations from the menu item edit modal',
      deleteMessage: 'This will remove the manual recommendation. The item may still appear based on calculated scores.',
      manual: 'Manual',
      auto: 'Auto'
    },
    zones: {
      title: 'Delivery Zones',
      subtitle: 'Manage delivery zones and their fees',
      addZone: 'Add Zone',
      editZone: 'Edit Zone',
      deleteZone: 'Delete Zone',
      zoneName: 'Zone Name (English)',
      arZoneName: 'Zone Name (Arabic)',
      fee: 'Delivery Fee',
      noZones: 'No zones configured for this branch',
      addSuccess: 'Zone added successfully',
      updateSuccess: 'Zone updated successfully',
      deleteSuccess: 'Zone deleted successfully',
      deleteConfirmation: 'Are you sure you want to delete this zone?',
      zoneNameRequired: 'Zone name is required',
      arZoneNameRequired: 'Arabic zone name is required',
      feeInvalid: 'Fee must be 0 or greater',
      zoneNamePlaceholder: 'e.g. City Center',
      arZoneNamePlaceholder: 'e.g. وسط المدينة'
    }
  }
};
